import { useIsTeamsQnaInOneEventsLandingPage } from '@ms/yammer-hooks/dist/teamsMeetings';
import { useTranslations } from '@ms/yammer-i18n-react';
import CommonStrings from '@ms/yammer-strings/dist/Common';
import TeamsMeetingStrings from '@ms/yammer-strings/dist/TeamsMeeting';
import { MultiColumnAppLayout } from '@ms/yammer-web-core-ui/dist/components/AppLayout';
import { FeatureBreakpoint, useContainerWidth } from '@ms/yammer-web-core-ui/dist/util/responsiveness';
import type { FC, PropsWithChildren } from 'react';
import React from 'react';

const AppLayout: FC<PropsWithChildren> = ({ children }) => {
  const t = useTranslations(TeamsMeetingStrings);
  const commonStrings = useTranslations(CommonStrings);
  const containerWidth = useContainerWidth();
  const isTeamsQnaInOneEventsLandingPage = useIsTeamsQnaInOneEventsLandingPage();
  const removeContentPadding = containerWidth < FeatureBreakpoint.Width500 || isTeamsQnaInOneEventsLandingPage;

  return (
    <MultiColumnAppLayout
      closeContentSidebarAriaLabel={commonStrings.commonClose()}
      openContentSidebarAriaLabel={t.teamsMeetingSettingsButtonAriaLabel()}
      removeContentPadding={removeContentPadding}
    >
      {children}
    </MultiColumnAppLayout>
  );
};

export default AppLayout;
